import { createFileRoute } from "@tanstack/react-router";
import AdminStickersPage from "@/admin/pages/stickers";

export const Route = createFileRoute("/admin/stickers/")({
  component: AdminStickersPage,
});
